import { Col, Row, Typography } from "antd";
import StaticPageBanner from "apps/Common/StaticPageBanner";
import { useGetContractByType } from "apps/CustomerPanel/Ad/ServerSideStates";
import { useGetPageDetailsByPageType } from "apps/FAQ/ServerSideStates";
import { Helmet } from "react-helmet-async";


const ProtectionPersonalDataIndex = () => {

  const contract = useGetContractByType("2004");
  const pageDetails = useGetPageDetailsByPageType(1003);
  const html = contract?.data?.data?.content || "";

  return (
    <>
 
      <Col xs={24} className="!overflow-hidden" > 
        <Row gutter={[0, 20]}>
          <Col span={24}>
          <StaticPageBanner
              title= {pageDetails?.data?.data?.name || ""}
              description= {pageDetails?.data?.data?.shortDescription || ""}
            />
            <Helmet>
                                                       <title className="capitalize">{"KVKK"}</title>
                                                 </Helmet>
          </Col>

          <Col xs={24}>
            <Row className="!px-2 lg:!px-6 xxl:!px-16" gutter={[20, 20]}>
              <Col xs={24}>
                <div dangerouslySetInnerHTML={{ __html: html }} />
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
      
    </>
  );
};

export default ProtectionPersonalDataIndex;
